
import { Location } from '@angular/common';
import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { EntityService,  ToastService, ControlsComponent } from '../../../blocks';
import { AppCodeGroup, ControlsParams, UserSessionService } from '../../../shared';
import { PatientVisitsService } from './../patient-visit.service';
import { PatientVisit } from './../patient-visit';
import { SelectizeComponent } from '../../../blocks';

import { takeUntil } from 'rxjs/operators' ;  import { Subject } from 'rxjs';
@Component({
    selector: 'sanabel-reopenVisit',
    templateUrl: './reopen-patient-visit.component.html'
})
export class ReopenPatVisit implements OnInit, OnDestroy {
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    @Input() patVisit: PatientVisit;
    editPatVisit: PatientVisit = <PatientVisit>{};
    controlsParams: ControlsParams;
    visitData: any;
    msgDataToggle: boolean = true;
    constructor(
        public translate: TranslateService,
        private _patientVisitsService: PatientVisitsService,
        private _entityService: EntityService,
        private _userSessionService: UserSessionService,
        private _router: Router,
        private _route: ActivatedRoute,
        private _location: Location,
        private _toastService: ToastService) {
        this.controlsParams = new ControlsParams(3120, AppCodeGroup.Buttons, true);
    }
    onClicked(e: number): void {
        switch (e) {
            case 1: //save code
                this.save();
                break;
            default:
                this.cancel();
        }
    }

    ngOnInit() {
        this.getVisit$();
        this.visitData = this._userSessionService.getModalKey('ClosePatVisit')["inputs"];
        this._getPatVisit(this.visitData['visitSerial']);
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    getVisit$() {
        this._userSessionService.getModalKey$().pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                if (keys.name == 'ReopenPatVisit' && keys.inputs) {
                    this._getPatVisit(keys.inputs['visitSerial']);
                }
            });
    }
    private _getPatVisit(visitSerial: number) {
     
        let nextVisitStatus = 1;  // send the next value of VisitStatus of currnet component for specific validation in Case Reopen visit Status Will be = 1
        if (visitSerial > 0) {
            this._patientVisitsService.getSpecificVisit(visitSerial, nextVisitStatus)
                .subscribe((visit) => {
                    if (visit['returnFlag']) {
                        this._setEditPatVisit(visit.data[0]);
                        this.msgDataToggle = true;
                        
                    }
                });
        }
    }

    private _setEditPatVisit(patVisit: PatientVisit) {
        this.patVisit = patVisit;
        this.editPatVisit = this._entityService.clone(this.patVisit);
    }
    save() {
        this.editPatVisit.visitStatus = 1;
        this.editPatVisit.startDate = this.editPatVisit.startDate;
        this.editPatVisit.endDate = null;
        this.editPatVisit.serial = this.visitData['visitSerial'];
        let patVisit = this.patVisit = this._entityService.merge(this.patVisit, this.editPatVisit);
        this._patientVisitsService.updateSpecificVisit(patVisit)
            .subscribe(coun => {
                this._userSessionService.closeModalKey('ReopenPatVisit', coun.data);
            }, error => console.log(error)
            );
        close();
    }

    cancel(showToast = true) {
        this._userSessionService.closeModalKey('ReopenPatVisit', 'Cross click');
    }

    _goBack(): void {
        this._location.back();
    }

}
